/**
 * Created by bartdecorte on 12/05/2017.
 */

class Util {
  static inArray(needle, haystack) {
    for (let i = 0; i < haystack.length; i++) {
      if (haystack[i] === needle) return true;
    }
    return false;
  }

  static getUrlParameter(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regexS = '[\\?&]' + name + '=([^&#]*)';
    let regex = new RegExp(regexS);
    let results = regex.exec(url);
    return results === null ? null : results[1];
  }

  static getValue($elt) {
    if ($elt.get(0).tagName === 'INPUT') {
      if ($elt.attr('type') === 'checkbox') return $elt.is(':checked');
    }
    return $elt.val();
  }

  static setValue($elt, value) {
    if ($elt.is('input') && $elt.attr('type') == 'checkbox') {
      $elt.prop('checked', value);
    } else {
      $elt.val(value);
    }
  }

  static capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static binaryAjaxTransport() {
    $.ajaxTransport('+binary', function(options, originalOptions, jqXHR) {
      if (
        window.FormData &&
        ((options.dataType && options.dataType == 'binary') ||
          (options.data &&
            ((window.ArrayBuffer && options.data instanceof ArrayBuffer) ||
              (window.Blob && options.data instanceof Blob))))
      ) {
        return {
          send: function(headers, callback) {
            const xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              dataType = options.responseType || 'blob',
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function() {
              const data = {};
              data[options.dataType] = xhr.response;
              callback(
                xhr.status,
                xhr.statusText,
                data,
                xhr.getAllResponseHeaders()
              );
            });

            xhr.open(type, url, async, username, password);

            for (let i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function() {
            jqXHR.abort();
          },
        };
      }
    });
    return;
  }
}

export default Util;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Util.js